export default __webpack_public_path__ + "static/media/out-sourcing-it-hero.f77756f1.png";